import type { AggStatus, InstitutionLoginProps } from './institutionLoginsTypes';

export function isErrorType(aggStatusString?: AggStatus | string | number | null): boolean {
  const acceptable = [
    'NEW',
    'OK',
    'MFA_CHALLENGE_READY_FOR_USER',
    'DISCOVERED_ACCOUNTS_READY_FOR_USER',
    'NO_ACCOUNTS_REFRESHED',
  ];
  return Boolean(aggStatusString && !acceptable.includes(String(aggStatusString)));
}

export function isPauthInvalidToken(aggStatus?: string | number | null): boolean {
  return Boolean(aggStatus && String(aggStatus) === 'PAUTH_INVALID_TOKEN');
}

export const isInstitutionLoginConnected = (institutionLogin: InstitutionLoginProps) => institutionLogin.isConnected;
